<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-16 19:09:02
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/VideoSize.vue
-->
<template>
    <div class="mt-5">
        <label class="flex items-center text-white text-sm mb-[10px]">
            {{
                props.label ||
                t(
                    props.type === 'IMAGE'
                        ? 'tools.image_size'
                        : 'tools.video_size'
                )
            }}
            <ClientOnly v-if="props?.show_tips">
                <el-popover
                    width="180"
                    :content="
                        tip_content || t('seo.textToImage.page.resolution')
                    "
                >
                    <template #reference>
                        <img
                            class="w-3 h-3 ml-2 cursor-help"
                            src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                            alt="Information icon"
                        />
                    </template>
                </el-popover>
            </ClientOnly>
        </label>
        <div class="grid grid-cols-3 gap-1 sm:gap-2">
            <button
                v-for="item in props.video_size_list"
                :key="item"
                @click="video_size = item"
                :class="[
                    'flex h-9 border border-transparent cursor-pointer  flex-col items-center justify-center gap-[10px] rounded-[10px] text-sm duration-300  p-[10px]  ',
                    video_size !== item
                        ? 'bg-[#1C1C20] border-white/[.06] hover:border-white/30 text-sub-title'
                        : '!border-white/50 !bg-white/10',
                ]"
            >
                <span
                    :class="[
                        'text-xs font-medium  transition-colors duration-200',
                        video_size === item ? 'text-white' : 'text-[#999]',
                    ]"
                >
                    {{ item }}
                </span>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'

const props = defineProps({
    video_size_list: {
        type: Array<any>,
        default: () => [],
    },
    type: {
        type: String,
        default: 'VIDEO',
    },
    show_tips: {
        type: Boolean,
        default: false,
    },
    tip_content: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: '',
    },
})

const { t, locale } = useI18n()

const video_size = defineModel('video_size')
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
